export default {
  title: 'Incorporación a Wolt Drive',
  subtitle: 'Visible solo para gestores de incorporación.',
  steps: {
    request: {
      title: '1. Solicitar el establecimiento a Wolt',
      description:
        'Copia la fila de este restaurante para la hoja compartida de Wolt. Pégala en la columna A de la siguiente fila vacía y avisa a Wolt en el canal conjunto de Slack.',
    },
    activate: {
      title: '2. Verificar y activar',
      description:
        'Introduce el ID de establecimiento que Wolt añadió a la hoja. Se comprueba con una cotización de prueba de Wolt antes de guardar nada.',
    },
  },
  fields: {
    venue_id: {
      label: 'ID de establecimiento Wolt',
      placeholder: 'p. ej. 6736f9f5f9e2ab82f9150420',
      invalid: 'Un ID de establecimiento Wolt tiene 24 caracteres y usa solo 0–9 y a–f.',
    },
    priority: {
      label: 'Prioridad de proveedor',
      options: {
        wolt_primary: 'Wolt principal, mantener los proveedores actuales como respaldo',
        wolt_only: 'Solo Wolt',
      },
    },
  },
  verification: {
    verified: 'Wolt confirmó este establecimiento.',
    failed: 'Wolt no pudo confirmar este establecimiento.',
    wolt_reason: 'Wolt dijo: {{reason}}',
    unavailable_now: 'Wolt no puede entregar desde este local en este momento ({{reason}}). Aún puedes guardarlo.',
  },
  preview: {
    label: 'Orden de proveedores',
    none: 'ninguno',
  },
  hints: {
    internal_delivery:
      'Este restaurante entrega con sus propios repartidores. Wolt se usa cuando el modo de entrega de abajo se configura en repartidores externos.',
    invalid_stored_id:
      'El ID de local guardado {{venueId}} no es un ID de local de Wolt válido, por lo que Wolt no se usa para este restaurante. Verifica y guarda el correcto.',
  },
  buttons: {
    copy_details: 'Copiar detalles',
    verify: 'Verificar',
    save: 'Guardar',
  },
  confirm: {
    title: '¿Activar Wolt Drive?',
    description: 'Guarda el ID de establecimiento {{venueId}} y cambia el orden de proveedores a: {{providers}}.',
    unsaved_providers: 'Los cambios no guardados en la lista de proveedores de abajo se reemplazarán.',
    ok: 'Guardar',
    cancel: 'Cancelar',
  },
  toasts: {
    copied: 'Copiado',
    copy_failed: 'No se pudieron copiar los detalles. Inténtalo de nuevo.',
    saved: 'Wolt Drive está configurado para este restaurante.',
    save_failed: 'No se pudo guardar. Inténtalo de nuevo.',
  },
};
